import styled from 'styled-components';
import { palette } from 'styled-tools';

export const Wrapper = styled.div`
	color: ${palette('white')};
	margin-bottom: 24px;
`;
